import React from 'react'
import Hero from './Sections/Hero/Hero'
import Subservices from './Sections/Subservices/Subservices'
import AppComparison from './Sections/AppComparison/AppComparison'
import CaseStudies from '../../Home/Components/CaseStudies'
import ProcessSection from './Sections/ProcessSection/ProcessSection'
import ClientSpeak from '../../Home/Components/ClientSpeak'
import Footer from '../../../Components/Footer/Footer'
import Navigation from '../../../Components/Navigation/Navigation'
import webAppImage from '../../../assets/images/web-app.png'
import Industries from './Sections/Industries/Industries'
import GetQuote from '../../../Components/GetQuote/GetQuote'
import Contect from '../../Home/Components/Contect'

const WebApp = () => {


    const homeContent = {
        title: "Revolutionize Your Digital Presence with Modern Web Applications",
        description: "business operations with KoolMind's comprehensive web development expertise spanning nearly a decade! Our seasoned developers create high-performance, cloud-native web solutions across Singapore, Malaysia, Thailand & India.",
        image: webAppImage,
        breadcrumb: "Web App",
    }

    const subservicesTitles = {
        header: "We specialize in delivering cutting-edge web solutions that drive measurable business growth.",
        subservices: [
            {
                iconFileName: "webdevelopment.svg",
                title: "Enterprise Web Application Development",
                subtitle: ""
            },
            {
                iconFileName: "dashbaord.svg",
                title: "Real-time Dashboard Creation",
                subtitle: ""
            },
            {
                iconFileName: "devops.svg",
                title: "Cloud Infrastructure & DevOps",
                subtitle: ""
            },
            {
                iconFileName: "apiIcon.svg",
                title: "API Gateway & Microservices",
                subtitle: ""
            },
            {
                iconFileName: "lagecy.svg",
                title: "Legacy System Modernization",
                subtitle: ""
            },
            {
                iconFileName: "perfomance.svg",
                title: "Performance Optimization Services",
                subtitle: "(Chat, Video, Collaboration)"
            },
            {
                iconFileName: "security.svg",
                title: "Security Implementation & Auditing",
                subtitle: ""
            },
            {
                iconFileName: "techanical.svg",
                title: "Maintenance & Technical Support",
                subtitle: ""
            }
        ]
    }

    const compareHeader = {
        title: "Difference between Server-Side Rendering & Client-Side Rendering",
        description: "Discover which rendering approach delivers superior performance, improves search visibility, and provides optimal user interactions!"
    }

    const diff1 = {
        title: "Server-side rendering (SSR)",
        features: [
            { text: "Optimal for SEO requirements" },
            { text: "Delivers faster initial page loads" },
            { text: "Superior search engine visibility" },
            { text: "Improved Core Web Vitals" },
            { text: "Reduced JavaScript bundle size" },
            { text: "Better accessibility compliance" },
            { text: "Instant content availability" },
            { text: "Eliminates loading spinners" },
            { text: "Enhanced social media sharing" },
            { text: "Functions reliably on slower connections" }
        ]
    }

    const diff2 = {
        title: "Client-side rendering (CSR)",
        features: [
            { text: "Dynamic user interface updates" },
            { text: "Seamless single-page experience" },
            { text: "Reduced server computational load" },
            { text: "Interactive user experiences" },
            { text: "Slower initial loading times" },
            { text: "Requires JavaScript execution" },
            { text: "Perfect for dashboard applications" },
            { text: "Limited SEO capabilities" },
            { text: "Complex state management" },
            { text: "Relies on modern browser features" }
        ]
    }

    const processSection = {
        title: "Web App Development",
        description: "Leading Southeast Asian businesses choose KoolMind for our proven methodology. Our approach prioritizes transparency, efficiency, and exceptional results. This comprehensive 6-phase framework guarantees successful project delivery within timeline and budget.",
        steps: [
            {
                title: "Requirements Discovery",
                description: "Our specialists perform comprehensive business analysis and identify technical requirements.",
                icon: "s1.svg"
            },
            {
                title: "Architecture Planning",
                description: "We design scalable system architecture and create detailed technical specifications.",
                icon: "s2.svg"
            },
            {
                title: "Interface Design",
                description: "Expert designers craft intuitive user experiences with modern interface standards.",
                icon: "s3.svg"
            },
            ,
            {
                title: "Development Execution",
                description: "Our engineers build robust web applications using industry-leading technologies.",
                icon: "s4.svg"
            },
            {
                title: "System Integration",
                description: "We seamlessly connect external services and ensure comprehensive functionality.",
                icon: "product-integration.svg"
            },
            {
                title: "Deployment & Maintenance",
                description: "Continuous monitoring and proactive maintenance ensure optimal application performance.",
                icon: "s5.svg"
            }
        ]
    }


    return (
        <div>
            <Navigation offer={true} />
            <Hero homeContent={homeContent} />
            <Subservices subservicesTitles={subservicesTitles} />
            <AppComparison compareHeader={compareHeader} diff1={diff1} diff2={diff2} />
            <ProcessSection processSection={processSection} />
            <CaseStudies />
            <Industries />
            <ClientSpeak />
            <GetQuote /> 
            <Contect />
            <Footer />
        </div>
    )
}

export default WebApp
